import * as yup from 'yup';

function name(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'EDITFORM_NAME_FIELD_IS_REQUIRED',
        defaultMessage: 'Name is required',
      }),
    )
    .max(
      200,
      formatMessage({
        id: 'EDITFORM_NAME_FIELD_MAX_CHARS_200',
        defaultMessage: 'Name should be less than 200 chars',
      }),
    );
}

function status(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CREATEFORM_STATUS_FIELD_IS_REQUIRED',
      defaultMessage: 'Status is required',
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      name: name(formatMessage),
      status: status(formatMessage),
    })
    .required();

export default validationSchema;
